import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../../store';

export const getOrdersFeatureState = createFeatureSelector<State>('orders');
export const getOrdersReturnState = createSelector(getOrdersFeatureState, state => state.returns);
export const getOrdersReturnReasons = createSelector(getOrdersReturnState, state => state && state.payload);
export const getOrdersReturnReasonsLoading = createSelector(getOrdersReturnState, state => state.loading);
